export default __webpack_public_path__ + "fonts/2f0b28545074b678c62bd06c616b0fc3.svg";